module.exports = __webpack_public_path__ + "f5d42418f23344eed1bc107e11b09bc5.svg";